import { aD as e, aE as t, aF as n, aG as r, e as u } from "./Array.bs-4b4ec77c.mjs";

import { e as i } from "./caml_obj-c29533cc.mjs";

import { f, b as s, r as c } from "./belt_Array-b9ebcaa6.mjs";

function placeholder(e) {}

function makeEmpty(e) {
  return {};
}

function _getUnsafe(e, t) {
  return e[t];
}

function getUnsafe() {
  if (1 === arguments.length) {
    const e = arguments;
    return function fn(t) {
      return _getUnsafe(t, e[0]);
    };
  }
  return _getUnsafe(arguments[0], arguments[1]);
}

var o = n;

function get() {
  if (1 === arguments.length) {
    const e = arguments;
    return function fn(t) {
      return o(t, e[0]);
    };
  }
  return o(arguments[0], arguments[1]);
}

function _prop(e, t) {
  return e[t];
}

function prop() {
  if (1 === arguments.length) {
    const e = arguments;
    return function fn(t) {
      return _prop(t, e[0]);
    };
  }
  return _prop(arguments[0], arguments[1]);
}

function toPairs(e) {
  return Object.entries(e);
}

var a = e;

function keys(e) {
  return Object.keys(e);
}

var l = t;

function _merge(e, t) {
  return Object.assign({}, e, t);
}

function merge() {
  if (1 === arguments.length) {
    const e = arguments;
    return function fn(t) {
      return _merge(t, e[0]);
    };
  }
  return _merge(arguments[0], arguments[1]);
}

function _set(e, t, n) {
  var r = merge({}, e);
  r[t] = n;
  return r;
}

function set() {
  if (2 === arguments.length) {
    const e = arguments;
    return function fn(t) {
      return _set(t, e[0], e[1]);
    };
  }
  return _set(arguments[0], arguments[1], arguments[2]);
}

function _update(e, t, r) {
  return set(e, t, r(n(e, t)));
}

function update() {
  if (2 === arguments.length) {
    const e = arguments;
    return function fn(t) {
      return _update(t, e[0], e[1]);
    };
  }
  return _update(arguments[0], arguments[1], arguments[2]);
}

function _updateUnsafe(e, t, n) {
  return set(e, t, n(e[t]));
}

function updateUnsafe() {
  if (2 === arguments.length) {
    const e = arguments;
    return function fn(t) {
      return _updateUnsafe(t, e[0], e[1]);
    };
  }
  return _updateUnsafe(arguments[0], arguments[1], arguments[2]);
}

function _deleteKey(e, t) {
  var n = merge({}, e);
  r(n, t);
  return n;
}

function deleteKey() {
  if (1 === arguments.length) {
    const e = arguments;
    return function fn(t) {
      return _deleteKey(t, e[0]);
    };
  }
  return _deleteKey(arguments[0], arguments[1]);
}

function _deleteKeys(e, t) {
  var n = merge({}, e);
  f(t, (function(e) {
    r(n, e);
  }));
  return n;
}

function deleteKeys() {
  if (1 === arguments.length) {
    const e = arguments;
    return function fn(t) {
      return _deleteKeys(t, e[0]);
    };
  }
  return _deleteKeys(arguments[0], arguments[1]);
}

function _map(e, n) {
  return t(s(Object.keys(e), (function(t) {
    return [ t, n(e[t]) ];
  })));
}

function map() {
  if (1 === arguments.length) {
    const e = arguments;
    return function fn(t) {
      return _map(t, e[0]);
    };
  }
  return _map(arguments[0], arguments[1]);
}

function _mapWithKey(e, n) {
  return t(s(Object.keys(e), (function(t) {
    return [ t, n(t, e[t]) ];
  })));
}

function mapWithKey() {
  if (1 === arguments.length) {
    const e = arguments;
    return function fn(t) {
      return _mapWithKey(t, e[0]);
    };
  }
  return _mapWithKey(arguments[0], arguments[1]);
}

function _filter(e, n) {
  return t(c(Object.keys(e), [], (function(t, r) {
    var i = e[r];
    if (n(i)) {
      return u(t, [ r, i ]);
    } else {
      return t;
    }
  })));
}

function filter() {
  if (1 === arguments.length) {
    const e = arguments;
    return function fn(t) {
      return _filter(t, e[0]);
    };
  }
  return _filter(arguments[0], arguments[1]);
}

function _filterWithKey(e, n) {
  return t(c(Object.keys(e), [], (function(t, r) {
    var i = e[r];
    if (n(r, i)) {
      return u(t, [ r, i ]);
    } else {
      return t;
    }
  })));
}

function filterWithKey() {
  if (1 === arguments.length) {
    const e = arguments;
    return function fn(t) {
      return _filterWithKey(t, e[0]);
    };
  }
  return _filterWithKey(arguments[0], arguments[1]);
}

function _reject(e, t) {
  return filter(e, (function(e) {
    return !t(e);
  }));
}

function reject() {
  if (1 === arguments.length) {
    const e = arguments;
    return function fn(t) {
      return _reject(t, e[0]);
    };
  }
  return _reject(arguments[0], arguments[1]);
}

function _rejectWithKey(e, t) {
  return filterWithKey(e, (function(e, n) {
    return !t(e, n);
  }));
}

function rejectWithKey() {
  if (1 === arguments.length) {
    const e = arguments;
    return function fn(t) {
      return _rejectWithKey(t, e[0]);
    };
  }
  return _rejectWithKey(arguments[0], arguments[1]);
}

function _selectKeys(e, t) {
  return filterWithKey(e, (function(e, n) {
    return function includes(e, t) {
      return t.includes(e);
    }(e, t);
  }));
}

function selectKeys() {
  if (1 === arguments.length) {
    const e = arguments;
    return function fn(t) {
      return _selectKeys(t, e[0]);
    };
  }
  return _selectKeys(arguments[0], arguments[1]);
}

function isEmpty(e) {
  return i(e, {});
}

function isNotEmpty(e) {
  return !i(e, {});
}

var y = {
  __proto__: null,
  placeholder,
  makeEmpty,
  getUnsafe,
  get,
  prop,
  toPairs,
  values: a,
  keys,
  fromPairs: l,
  merge,
  set,
  update,
  updateUnsafe,
  deleteKey,
  deleteKeys,
  map,
  mapWithKey,
  filter,
  filterWithKey,
  reject,
  rejectWithKey,
  selectKeys,
  isEmpty,
  isNotEmpty
};

export { get as a, prop as b, merge as c, updateUnsafe as d, deleteKey as e, l as f, getUnsafe as g, deleteKeys as h, y as i, map as j, keys as k, mapWithKey as l, makeEmpty as m, filter as n, filterWithKey as o, placeholder as p, rejectWithKey as q, reject as r, set as s, toPairs as t, update as u, a as v, selectKeys as w, isEmpty as x, isNotEmpty as y };
